export default "__VITE_ASSET__zN8nZPN7__"